<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <p>{{ message }}</p>
  <bdg-form [formGroup]="form" [formValidator]="validator">
    <bdg-text-area-field
      [label]="label"
      [control]="control"
      [placeholder]="placeholder"
      cdkFocusInitial
      [maxLength]="maxLength"
      [style.height.px]="150"
    ></bdg-text-area-field>
  </bdg-form>
</div>
<div mat-dialog-actions class="justify-content-end">
  <button *ngIf="secondaryOption" mat-stroked-button class="border-0" color="primary" [mat-dialog-close]="false">
    {{ secondaryOption }}
  </button>
  <button
    mat-raised-button
    [disabled]="!form.valid"
    class="border-0"
    [color]="primaryOptionColor"
    [mat-dialog-close]="control.value"
  >
    {{ primaryOption }}
  </button>
</div>
